// import { createI18n } from "vue-i18n";
// import { getBrowserLocale, supportedLocalesInclude, removeEmptyTradKeys } from "../modules/utils";

const fr = require("../locales/fr.json");
const de = require("../locales/de.json");

// let locale = getBrowserLocale({ countryCodeOnly: true });
// if (!supportedLocalesInclude(locale)) {
//   locale = "fr";
// }

// const i18n = createI18n({
//   legacy: false, // Utiliser la composition API
//   globalInjection: true, // Injecter $t et $i18n globalement
//   locale,
//   fallbackLocale: "fr",
//   messages: {
//     fr: removeEmptyTradKeys(fr),
//     de: removeEmptyTradKeys(de),
//   },
// });

// export default i18n;

export {
  fr,
  de,
};
